<h2 mat-dialog-title class="treeslo-modal-header">
    <span class="treeslo-modal-header__title">{{ 'contact_us_support.title' | translate }}</span>
    <button type="button" mat-icon-button class="treeslo-modal-header__close" mat-dialog-close
        [attr.aria-label]="'common.close' | translate">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content>
    <div class="contact-us-layout">
        <form [formGroup]="contactForm" class="contact-us-form treeslo-modal-form">
            <div class="contact-us-fields-row">
                <mat-form-field *ngIf="stores.length" appearance="outline" class="full-width"
                    subscriptSizing="dynamic">
                    <mat-label>{{ 'contact_us_support.fields.store' | translate }}</mat-label>
                    <mat-select formControlName="storeId">
                        <mat-option *ngFor="let store of stores" [value]="store.storeId">
                            {{ store.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                    <mat-label>{{ 'contact_us_support.fields.issue_type' | translate }}</mat-label>
                    <mat-select formControlName="category">
                        <mat-option *ngFor="let option of issueTypeOptions" [value]="option.value">
                            {{ option.translationKey | translate }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="contactForm.get('category')?.hasError('required')">
                        {{ 'contact_us_support.errors.issue_type_required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="full-width contact-us-description-field"
                subscriptSizing="dynamic" floatLabel="always">
                <mat-label>{{ 'contact_us_support.fields.description' | translate }}</mat-label>
                <textarea class="contact-us-description" matInput formControlName="description" rows="4"
                    placeholder="{{ 'contact_us_support.placeholders.describe_issue' | translate }}"></textarea>
                <mat-error *ngIf="contactForm.get('description')?.hasError('required')">
                    {{ 'contact_us_support.errors.description_required' | translate }}
                </mat-error>
            </mat-form-field>

            <div class="upload-section">
                <input #screenshotFileInput type="file" multiple class="upload-input"
                    (change)="onFileSelected($event)" />
                <button mat-stroked-button color="primary" type="button" (click)="screenshotFileInput.click()"
                    [disabled]="!contactForm.valid || !contactForm.get('storeId')?.value || isUploadingFiles || selectedFiles.length >= allowedFilesAmountPerTicket">
                    <span class="upload-button-content">
                        <i-tabler name="upload"></i-tabler>
                        {{ 'contact_us_support.actions.upload_files' | translate }}
                    </span>
                </button>

                <div class="upload-status" *ngIf="isUploadingFiles || uploadError">
                    <app-loader *ngIf="isUploadingFiles"></app-loader>
                    <p *ngIf="uploadError" class="upload-error">{{ uploadError | translate }}</p>
                </div>
            </div>
        </form>

        <div class="thumbnails-panel" *ngIf="selectedFiles.length">
            <h4>{{ 'contact_us_support.headers.uploaded_files' | translate }}</h4>
            <div class="thumbnails-grid">
                <div class="thumb-item" *ngFor="let file of selectedFiles; let i = index">
                    <div class="thumb-container">
                        <ng-container *ngIf="file.isImage; else nonImageThumb">
                            <img [src]="file.previewUrl" [alt]="file.fileName" />
                        </ng-container>
                        <ng-template #nonImageThumb>
                            <div class="thumb-non-image">{{ file.extension }}</div>
                        </ng-template>

                        <button mat-icon-button class="remove-icon" (click)="removeSupportingFile(i)" type="button"
                            matTooltip="{{ 'contact_us_support.tooltips.remove_file' | translate }}">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    <div class="thumb-name" title="{{ file.fileName }}">{{ file.fileName }}</div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="treeslo-modal-actions">
        <button mat-button type="button" mat-dialog-close>{{ 'contact_us_support.actions.close' | translate }}</button>
        <button mat-flat-button color="primary" type="button" (click)="submit()"
            [disabled]="!contactForm.valid || isUploadingFiles">
            {{ 'contact_us_support.actions.send' | translate }}
        </button>
    </div>
</mat-dialog-actions>
